export default {
  "content": "<g stroke=\"#838BF6\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17.25 4.5l-7.125 7.125-3.75-3.75L.75 13.5\"/><path d=\"M12.75 4.5h4.5V9\"/></g>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};